import React from 'react';
import helper from 'components/utils/helper';
import { Container, LeftCol, RightCol, Header, Cta } from './Block2Column.style';

const Block2Column = (data) => {
    return (
        <Container>
            <LeftCol>
                {data.left_column_header &&
                    <Header>{data.left_column_header}</Header>
                }
                <div>{helper.renderParagraph(data.left_column_paragraph)}</div>
                { data.left_column_cta &&
                    <Cta href={data.left_column_link}>
                        {data.left_column_cta}
                        <img src="resources/images/icons/arrow.png" alt="arrow" />
                    </Cta>
                }
            </LeftCol>
            <RightCol>{helper.renderImage(data.right_column_image)}</RightCol>
           
        </Container>
    );
}
 
export default Block2Column;